module.exports = __webpack_public_path__ + "img/164-croatia.756fd3f6.svg";